export enum sortDirection {
  asc = 'asc',
  desc = 'desc',
}
